import { useQuery } from 'react-query'

import { request } from '../api/apiCore'

const fetchProcedures = () => request({ url: '/admin/procedures' })

export const useProceduresData = () => useQuery('procedures', fetchProcedures)
